// Objekte archivieren statt löschen (Entscheidung 12.10.2026) – über das vorhandene Feld
// objekte.status, ohne Datenbankänderung. Archivierte Objekte fehlen in Liste und Portfolio,
// bleiben aber vollständig erhalten und lassen sich wiederherstellen.

import { supabase } from '../supabase/client';

export const ARCHIV_STATUS = 'Archiviert';

export function istArchiviert(status: string | null | undefined): boolean {
  return (status ?? '').trim().toLowerCase() === 'archiviert';
}

export async function setzeArchiviert(objektId: string, archivieren: boolean): Promise<void> {
  const { error } = await supabase.from('objekte').update({ status: archivieren ? ARCHIV_STATUS : 'Aktiv' }).eq('id', objektId);
  if (error) throw new Error(error.message);
}

/** Löschen scheitert an verknüpften Daten (Fremdschlüssel, z. B. künftige Mietkonto-Buchungen)? */
export function istVerknuepfungsFehler(meldung: string): boolean {
  return /foreign key|violates|23503|still referenced/i.test(meldung);
}
